import { Reducer } from 'redux';

import { AdminRolesMessageActions } from '../../domains/adminRoles/actions.types';

import { AdminRoles } from './types';

export type AdminRolesActions = AdminRolesMessageActions;

const initialState: AdminRoles = {
  message: '',
  messageType: 'success',
  isMessageBarVisible: false,
};

const reducer: Reducer<AdminRoles, AdminRolesActions> = (state = initialState, action) => {
  switch (action.type) {
    case 'ADMIN_ROLES.MESSAGE_UPDATE':
      return {
        ...state,
        message: action.payload.message,
        messageType: action.payload.messageType,
        isMessageBarVisible: true,
      };
    case 'ADMIN_ROLES.MESSAGE_CLEAR':
      return { ...state, message: '', isMessageBarVisible: false };
    default:
      return state;
  }
};

export default reducer;
